import { useTranslation } from 'react-i18next'

import { useInlineNotifications } from '../../../../../../hooks'
import { useCloseConfirm } from '../../../../../Form'
import { FormikForm } from '../../../../../Formik'
import { WidgetFormContainer } from '../../../../../Widget'
import { useListingProfileContext } from '../../RentalPortalListingProfile.hooks'
import { useListingProfileBlockSave } from '../../RentalPortalListingProfileExpose'
import { LISTING_PROFILE_ADDRESS_DISCARD_CONFIRMATION_PROPS } from '../RentalPortalListingProfileWidgetAddress.constants'
import {
  getListingAddressInitialValues,
  getListingAddressPatchPayload,
  getListingAddressValidationSchema,
} from '../RentalPortalListingProfileWidgetAddress.utils'

import { ListingProfileWidgetAddressFormFields } from './ListingProfileWidgetAddressFormFields'

function ListingProfileWidgetAddressForm({ onClose, onSuccess }) {
  const { t } = useTranslation()

  const { listingData } = useListingProfileContext()

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const { handleSaveBlock } = useListingProfileBlockSave({
    onClose,
    onRemoveNotification: handleRemoveNotification,
    onSetNotification: handleAddNotification,
  })

  const initialValues = getListingAddressInitialValues({
    listing: listingData,
    t,
  })

  function handleSubmit(values, formikHelpers) {
    handleSaveBlock({
      formikHelpers,
      payload: getListingAddressPatchPayload(values),
      onSuccess,
    })
  }

  return (
    <FormikForm
      Container={WidgetFormContainer}
      containerProps={{
        confirmationProps: LISTING_PROFILE_ADDRESS_DISCARD_CONFIRMATION_PROPS,
        isCloseConfirm,
        setCloseConfirm,
        onClose,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getListingAddressValidationSchema({ initialValues })}
      onSubmit={handleSubmit}
    >
      <ListingProfileWidgetAddressFormFields
        isCloseConfirm={isCloseConfirm}
        notifications={notifications}
        onCancel={handleClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default ListingProfileWidgetAddressForm
